import { MutableRefObject } from 'react';

import { useBreadcrumbs } from '../Breadcrumbs/useBreadcrumbs';

// This is needed to compensate for the height
// of the breadcrumbs panel when scrolling the page
export function useRightSidePanelScroll(panelRef: MutableRefObject<HTMLDivElement | null>) {
  const { breadcrumbsContainerRef } = useBreadcrumbs();

  return () => {
    if(!panelRef.current || !breadcrumbsContainerRef.current) return;

    const breadcrumbsRect: DOMRect = breadcrumbsContainerRef.current.getBoundingClientRect();
    const DEFAULT_OFFSET: number = breadcrumbsRect.top + breadcrumbsRect.height + document.documentElement.scrollTop;
    const newOffset: number = window.scrollY <= DEFAULT_OFFSET ? DEFAULT_OFFSET - window.scrollY : 0;

    panelRef.current.style.top = `${newOffset}px`;
    panelRef.current.style.height = `calc(100% - ${newOffset}px)`;
  };
}
